import { render, staticRenderFns } from "./MasterTypePower.vue?vue&type=template&id=06f37e95&scoped=true"
import script from "./MasterTypePower.vue?vue&type=script&lang=js"
export * from "./MasterTypePower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f37e95",
  null
  
)

export default component.exports